export const UPDATE_AREAS = 500
